module.exports = __webpack_public_path__ + "static/media/productos_otros_arandano.d1ddab6b.jpg";